<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div *ngIf="isPageReady" class="flex flex-col h-full">

    <div class="p-3">
      <div class="qb-detail-card qb-primary-tint p-4">
        <table class="qb-info-table w-full">
          <tr>
            <td class="label">Style</td>
            <td class="value">{{ params.styleCode }}</td>
          </tr>
          <tr>
            <td class="label">Change from</td>
            <td class="value font-semibold">{{ params.fromColorName }}</td>
          </tr>
          <tr>
            <td class="label">Products affected</td>
            <td class="value">{{ affectedCount }}</td>
          </tr>
        </table>
      </div>
    </div>

    <!-- This is not a local relabel. The change travels the whole way out. -->
    <div class="mx-3 mb-2 p-3 qb-detail-card" style="border-color: var(--p-red-500, #ef4444)">
      <div class="text-sm font-semibold mb-1" style="color: var(--p-red-500, #ef4444)">
        <i class="pi pi-exclamation-triangle mr-1"></i>This change goes all the way through to Proximity
      </div>
      <div class="text-sm">
        Every product of this style moves to the new color, and the change is sent to Proximity on the next
        push. Proximity price lists and program product lists that refer to this color are affected. Do not
        use this to correct a spelling &mdash; it re-points real products.
      </div>
    </div>

    <div class="px-3 pb-2 text-sm">
      Select the color the manufacturer uses for this style.
    </div>

    <div class="flex-1 min-h-0 overflow-auto px-3 pb-3">
      <div *ngFor="let t of targets"
           class="flex items-center gap-3 p-2 border-b cursor-pointer"
           [style.opacity]="t.alreadyOnStyle ? 0.45 : 1"
           [style.background]="selected === t ? 'var(--p-primary-50)' : 'transparent'"
           (click)="t.alreadyOnStyle ? null : (selected = t)">
        <p-radioButton [value]="t" [(ngModel)]="selected" [disabled]="t.alreadyOnStyle"
                       name="target" [inputId]="'t' + t.featureChoice.id" />
        <span class="flex-1">{{ t.label }}</span>
        <span class="text-sm" style="color: var(--p-text-muted-color)">{{ t.pms }}</span>
        <span *ngIf="t.alreadyOnStyle" class="text-sm" style="color: var(--p-red-500, #ef4444)">
          already on this style
        </span>
      </div>

      <div *ngIf="targets.length === 0" class="p-3 text-sm italic" style="color: var(--p-text-muted-color)">
        No color the manufacturer publishes for this style is in the Uniformax color list yet.
        Add it on the Features page first.
      </div>
    </div>

    <div *ngIf="errorMessage" class="px-3 pb-2 text-sm" style="color: var(--p-red-500, #ef4444)">
      {{ errorMessage }}
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button pButton type="button" class="p-button-raised" [disabled]="!canSave" [loading]="isSaving"
            (click)="onOk()">
      <span>Change Color</span>
    </button>
    <button pButton type="button" class="p-button-raised" (click)="onCancel()">
      <span>Cancel</span>
    </button>
  </div>
</ng-template>
